console.log('search loaded ...');

$(function() {

	var actionURL = $('#searchform').attr('action'), // Save form action url in variable
		searchinput = $('.page-typeahead-input'),
		resultsLayerClass = 'page-typeahead-results';

	$('<div class="' + resultsLayerClass + '"></div>').appendTo('body');

	searchinput.typeahead({
		cache: false,
		debug: true,
		// input: '#q',
		order: 'desc',
		hint: true,
		minLength: 3,
		// cache: false,
		accent: true,
		display: ['title'], // Search objects by the title-key
		dynamic: true,
		/*
		backdrop: {
			"opacity": 1,
			"background-color": "#FFFFFF"
		},
		*/
		backdrop: false,
		backdropOnFocus: false,
		href: "{{url}}",
		// emptyTemplate: "Kein Suchergebnis für {{query}}",
		emptyTemplate: 'Kein Suchergebnis',
		searchOnFocus: false, // true,
		cancelButton: false,
		source: {
			// url: actionURL // Ajax request to get JSON from the action url
			ajax: {
				method: "GET",
				url: actionURL,
				data: {
					q: '{{query}}'
				},
			}
		},
		callback: {
			/*
			onHideLayout: function (node, query) {
				$('#searchform').hide();
				console.log('hide search');
			}
			onInit: function(node) {
			},
			onResult: function (node, query, result, resultCount, resultCountPerGroup) {
				_adjustSearchResultsLayer();
			}
			onPopulateSource: function (node, data, group, path) {
			},
			onSearch: function (node, query) {
				_adjustSearchResultsLayer();
			},
			*/
			onShowLayout: function (node, query) {
				/*
				if (ResponsiveBootstrapToolkit.is('>sm')) {
					_adjustSearchResultsLayer();
				} else {
					_closeSearchResultsLayer();
				}
				*/
				// show layer in every viewport
				_adjustSearchResultsLayer();
			}
		},
		filter: false, // EDIT: If you also want to find the query string in other fields than the title make sure you add
		resultContainer: '.' + resultsLayerClass
	});



	function _adjustSearchResultsLayer () {
		var results_container = $('.' + resultsLayerClass);
		results_container
			.show()
			.position({
				"of": searchinput,
				"my": "left top",
				"at": "left bottom"
			});
		if (ResponsiveBootstrapToolkit.is('<=md')) {
			results_container.width($('.page-nav-search-input-wrapper').width());
		} else {
			results_container.width($('.page-nav-search-form').width());
		}
	}

	// adjust search results layer
	$(window).on('orientationchange resize', function (e) {
		if (e.type === 'resize' && typeof (IS_TOUCH_DEVICE) !== 'undefined' && IS_TOUCH_DEVICE) { // prevents resize event from being mistakenly triggered on touch devices // see inline header javascript
			return;
		}
		// _adjustSearchResultsLayer();
		_closeSearchResultsLayer();
	});
	$(window).on('scroll', function (e) {
		if (ResponsiveBootstrapToolkit.is('>sm')) {
			_adjustSearchResultsLayer();
		} else {
			_closeSearchResultsLayer();
		}
	});
	// _adjustSearchResultsLayer();

	searchinput.on('blur', function(e) {
		setTimeout(function () {
			_closeSearchResultsLayer();
		}, 200);
	});

	window._closeSearchResultsLayer = function () {
		var results_container = $('.' + resultsLayerClass);
		results_container.hide();
	}

});



